<template>
  <div id="bulletin-page">
      <tab-header :key="$route.path" :id="id" :ex="4" :mode="true"/>
      <div id="contents-wrapper">
        <template v-if="pname === 'Board'">
        <div id="board-area">
          <h1>{{title}}</h1>
          <div class="search-wrapper">
            <div class="search-area">
              <v-select
                v-model="select"
                :items="['제목','작성자']"
                style="font-size: 1.1rem; width: 150px;"
              ></v-select>
            </div>
            <div class="search-box">
              <v-text-field
                v-model="searching"
                append-icon="mdi-magnify"
                @keyup.enter="search"
              ></v-text-field>
            </div>
          </div>
          <div class="board-list">
            <table style="width:100%">
              <thead>
                <tr>
                  <th class="number">번호</th>
                  <th class="title0">제목</th>
                  <th class="file">첨부파일</th>
                  <th class="writer">작성자</th>
                  <th class="hit">조회수</th>
                  <th class="date">등록일</th>
                </tr>
              </thead>
              <tbody v-if="this.$store.state.home.boards.list">
                <template v-for="(item, i) in this.$store.state.home.boards.list">
                  <tr :key="i" :class="{'notice': item.notice}">
                    <td class="number">{{i+(currpage-1)*10+1}}</td>
                    <td class="title0" style="text-align:left">
                      <span v-if="item.notice" class="notice-icon"><strong>공지</strong></span>
                      <router-link :to="`/board/${id}/contents/${item.id}`">{{item.title}}</router-link>
                      <!--<span class="comment">
                        <strong>(0)</strong>
                      </span>-->
                    </td>
                    <td class="file"><i v-if="item.files" class="fas fa-paperclip"></i></td>
                    <td class="writer">{{writer(item.writer)}}</td>
                    <td class="hit">{{item.hit}}</td>
                    <td class="date">{{item.update.toString().substring(0,10)}}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <div class="paging-btns-wrapper">
          <!-- <div class="btn-left"></div> -->
          <p class="paging-navigation">
            <a class="btn-first" v-if="hasPrevPage" @click="changePrevPage()">
              이전
            </a>
            <template v-for="i in totalpages">
              <span
                v-if="i < 6"
                :key="i"
                :class="{'strong': i + (pagenation * 5) == currpage}"
                @click="changePageByNumber(i + (pagenation * 5))" >
                  {{i + (pagenation * 5)}}
              </span>
            </template>
            <a class="btn-last" v-if="pagenation < parseInt(totalpages/5)" @click="changeNextPage()">
              다음
            </a>
          </p>
          <div class="btn-write" v-if="isAuth">
            <v-btn
              v-if="isAdimin"
              rounded
              text
              outlined
              min-width="200px"
              min-height="50px"
              :to="`/board/${id}/editor`"
            >
              글쓰기
            </v-btn>
          </div>
        </div>
        </template>
        <template v-else-if="pname === 'Editor'">
          <board-editor/>
        </template>
        <template v-else-if="pname === 'ContentsEditor'">
          <contents-editor/>
        </template>
        <template v-else>
          <board-contents/>
        </template>
      </div>
      <app-footer/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TabHeader from '../../../components/utils/common/TabHeader.vue'
import AppFooter from '../../../components/utils/AppFooter.vue'
import BoardEditor from './BoardEditor.vue'
import BoardContents from './BoardContents.vue'
import ContentsEditor from './ContentsEditor.vue'

export default {
  components: { TabHeader, AppFooter, BoardEditor, BoardContents, ContentsEditor },
  props: ['id', 'pname'],
  mounted () {
    this.type = this.types[this.$route.params.id]
    // this.$store.dispatch('home/fetchBoardList', { type: this.type, page: 1 })
  },
  data () {
    return {
      select: '제목',
      items: ['제목', '작성자'],
      searching: '',
      titles: ['Q & A', '공지사항','교육자료','Q & A'],
      types: ['qna', 'photo', 'data', 'qna'],
      list: [],
      type: '',
      currpage: 1,
      pagenation: 0
    }
  },
  watch: {
    $route (to, from) {
      this.type = this.types[this.$route.params.id]
      this.$store.dispatch('home/fetchBoardList', { type: this.type, page: 1 })
      this.pagenation = 0
      this.currpage = 1
      if (this.id === 2) this.id += 1
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuth', 'getUser']),
    /**
     * 카테고리 title 가져오기
     * @returns {string} id에 따른 카테고리 이름 반환
     */
    title () {
      return this.titles[this.id]
    },
    /**
     * 현재 페이지에 몇개의 글이 있는지 계산
     * @returns {int} 현재 페이지에 있는 글의 갯수 반환
     */
    totalpages () {
      const total = this.$store.state.home.boards.total
      return total ? Math.ceil(total / 10) - this.pagenation * 5 : 1
    },
    /**
     * 이전 페이지가 있는지 없는지 판별
     * @returns {boolean} 이전 페이지가 있으면 참, 없으면 거짓 반환
     */
    hasPrevPage () {
      const pages = parseInt(this.totalpages / 5)
      if (this.pagenation === 0 && !pages) return false
      return this.pagenation >= pages
    },
    isAdimin () {
      return this.getUser ? this.getUser.per_edu : false
    }
  },
  methods: {
    /**
     * 특정 페이지로 이동
     * @param {int} i 페이지의 숫자
     * @returns {undefined} 아무것도 반환하지 않음
     */
    changePageByNumber (i) {
      this.currpage = i
      this.getBoardList()
      // this.$store.dispatch('home/fetchBoardList', { type: this.type, page: i })
    },
    /**
     * 다음 페이지로 이동
     * 페이지를 5개 이동시키고 글 리스트 reload
     * @returns {undefined} 아무것도 반환하지 않음
     */
    changeNextPage () {
      this.pagenation += 1
      this.currpage = this.pagenation * 5 + 1
      this.getBoardList()
      // this.$store.dispatch('home/fetchBoardList', { type: this.type, page: this.currpage })
    },
    /**
     * 이전 페이지로 이동
     * 페이지를 5개 이동시키고 글 리스트 reload
     * @returns {undefined} 아무것도 반환하지 않음
     */
    changePrevPage () {
      this.pagenation -= 1
      this.currpage = this.pagenation * 5 + 1
      this.getBoardList()
      // this.$store.dispatch('home/fetchBoardList', { type: this.type, page: this.currpage })
    },
    /**
     * 작성자 이름 에서 @ 앞에부분만 잘라내기
     * @param {string} item 작성자 이름
     * @returns {string} 잘라진 문자열 반환
     */
    writer (item) {
      const idx = item.indexOf('@')
      if (idx === -1) {
        return item
      } else {
        return item.substring(0, idx)
      }
    },
    /**
     * 검색
     * 제목 또는 작성자를 기준으로 검색
     * @returns {undefined} 아무것도 반환하지 않음
     */
    search () {
      this.currpage = 1
      this.pagenation = 0
      this.getBoardList()
    },
    /**
     * 글 리스트를 가져오는 action 호출
     * 상황에 따라 다르게 action 호출
     * @returns {undefined} 아무것도 반환하지 않음
     */
    getBoardList () {
      if (this.searching !== '' && this.searching !== undefined && this.searching !== null) {
        console.log(this.searching, typeof this.searching)
        this.$store.dispatch('home/fetchBoardList', { type: this.type, page: this.currpage, search: this.searching, searchType: this.select })
      } else {
        this.$store.dispatch('home/fetchBoardList', { type: this.type, page: this.currpage })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
a {
  color: inherit;
  text-decoration: none;
  background: transparent;
}
#contents-wrapper{
  width: 100%;
  margin-top: 280px;
  padding: 30px 100px;
}
#board-area{
  padding-bottom: 30px;
  & > h1{
    text-align: center;
    font-size: 2.5rem;
    padding-bottom: 30px;
  }
  .search-wrapper{
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;
    .search-box{
      width: 25%;
      margin-left: 10px;
    }
  }
}
.board-list{
  border-top: 3px solid black;
}
.board-list table thead th {
    color: #212121;
    font-size: 1.3rem;
    line-height: 26px;
    padding: 20px 15px;
    font-weight: bold;
    border-bottom: 1px solid #e0e0e0;
    border-right: 1px solid #ddd;
    background: #eeecec;
}
.board-list table .number {
    width: 130px;
}
.board-list table .title0,
.board-list table .title2,
.board-list table .class-content {
    width: auto;
}
.board-list table .title0{
  padding-left: 30px;
}
.board-list table .notice {
  background-color: #EFF6FB;
}
.board-list table .notice span.notice-icon{
  border: 2px solid #2156d0;
  padding: 3px 7px;
  border-radius: 5px;
  margin-right: 12px;
  color: #2156d0;
}
.board-list table .comment > strong {
    color: #2156d0;
    font-weight: 500;
}

.board-list table .file,
.board-list table .hit{
  width: 110px;
}
.board-list table .date,
.board-list table .writer{
    width: 155px;
}
.board-list table tbody tr{
  border: 1px solid #ddd;
}
.board-list table tbody td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    color: #616161;
    font-size: 1.2rem;
    line-height: 26px;
    text-align: center;
    padding: 20px 10px;
}
.paging-btns-wrapper {
    position: relative;
    margin: 30px 0 20px 0;
    .btn-write{
        position: absolute;
        right: 0px;
        bottom: 0px;
        & > .v-btn{
          font-size: 1.2rem !important;
          border-radius: 25px;
          border: 2px solid #2156d0;
          color: #2156d0;
        }
    }
}
.paging-navigation {
    clear: both;
    text-align: center;
    padding-bottom: 0;
    margin: 30px 0 20px 0;
    text-align: center;
    .strong {
      display: inline-block;
      line-height: 40px;
      min-width: 45px;
      height: 45px;
      padding: 0 5px;
      margin: 0 5px;
      background: #fff;
      color: #2156d0;
      border: 1px solid #2156d0;
      vertical-align: middle;
      font-size: 1.3rem;
      font-weight: 700;
    }
    span {
      display: inline-block;
      line-height: 40px;
      min-width: 45px;
      height: 45px;
      padding: 0 5px;
      color: #555555;
      font-size: 1.3rem;
      border: 1px solid #fff;
      vertical-align: middle;
    }
}
</style>
